import styled from 'styled-components';

export const SmoothlyLoadingImage = styled.img<{ loaded: boolean }>`
  transition: opacity 0.6s ease-in-out, transform 0.6s ease-in-out;
  opacity: ${(props) => (props.loaded ? 1 : 0)};
  transform: ${(props) => (props.loaded ? 'scale(1)' : 'scale(1.05)')};
`;
